export enum ActionType {
    Cart = 'cart',
    Feedback = 'feedback',
    Tracking = 'tracking',
    OrderDetails = 'order_details',
    OrderHistory = 'order_history',
    OrderPollingScreen = 'polling_screen',
    Deeplink = "deeplink"
};